import { FC, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useAccount } from "wagmi";

import type { IPaginationResult } from "@dzambalaorg/types-collection";
import { ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { useApiCall } from "@dzambalaorg/react-hooks";
import { type ITemplate, TokenType } from "@framework/types";

import { MultiCarouselHierarchy } from "../multi-carousel-hierarchy";
import { TemplateListItem } from "../../../components";
import { StyledTitle } from "./styled";

export const NewErc998: FC = () => {
  const { chainId } = useAccount();
  const [templates, setTemplates] = useState<Array<ITemplate>>([]);

  const { fn, isLoading } = useApiCall(
    async api => {
      return api.fetchJson({
        url: "/templates/new",
        data: {
          contractType: TokenType.ERC998,
        },
      });
    },
    { success: false, error: false },
  );

  const fetchTokens = async (): Promise<void> => {
    return fn()
      .then((json: IPaginationResult<ITemplate>) => {
        setTemplates(json.rows);
      })
      .catch(e => {
        console.error(e);
      });
  };

  useEffect(() => {
    void fetchTokens();
  }, [chainId]);

  if (!templates || templates.length === 0) {
    return null;
  }

  return (
    <ProgressOverlay isLoading={isLoading}>
      <StyledTitle variant="h4">
        <FormattedMessage id="pages.landing.erc998-new" />
      </StyledTitle>
      <MultiCarouselHierarchy templates={templates} path="/erc998/templates" component={TemplateListItem} />
    </ProgressOverlay>
  );
};
